
import { deviationKindToTagColor } from '@src/constants'
import Tag from '../Tag/Tag'

export default function DeviationKindTag ({ children: kind, ...props }) {
  return <Tag {...props} color={deviationKindToTagColor(kind)}>{kind}</Tag>
}
